import { useCopies } from "shared/hooks/useCopies";
import { PurchaseConfirmationPropTypes } from "../../types";
import { PaymentSuccessTransactionSubSet, TransactionStatus } from "shared/enums/TransactionStatus";

function PurchaseStatus(props: PurchaseConfirmationPropTypes) {
  const copies = useCopies();

  if (
    !(
      props.approvalPending ||
      PaymentSuccessTransactionSubSet.includes(props.purchaseOrder?.transaction?.status as TransactionStatus)
    )
  )
    return null;

  return (
    <div className="purchaseConfirm_status">
      {props.approvalPending ? (
        <p className="purchaseConfirm_status--pendingReview">{copies.get("pending.review")}</p>
      ) : (
        PaymentSuccessTransactionSubSet.includes(props.purchaseOrder?.transaction?.status as TransactionStatus) && (
          <p className="purchaseConfirm_status--paymentReceived">{copies.get("payment.received")}</p>
        )
      )}
    </div>
  );
}

export default PurchaseStatus;
